class PostBlockSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.container = this.querySelector('.post-block-carousel');
    this.navigation = this.querySelector('.swiper-navigation');
    this.id = this.dataset.id;
    this.gap = this.dataset.gap;
    this.carouselId = `post-block-carousel-${this.id}`;
    this.paginationId = `swiper-pagination-${this.id}`;
    this.navigationPrevId = `swiper-button-prev-${this.id}`;
    this.navigationNextId = `swiper-button-next-${this.id}`;
    this.navigationWrapperId = `swiper-navigation-wrapper-${this.id}`;

    this.initSlider();
    this.setArrowPositions();

    this.handleResize = debounce(
      () => this.setArrowPositions(),
      ON_CHANGE_DEBOUNCE_TIMER
    );
    window.addEventListener('resize', this.handleResize);
  }

  initSlider() {
    const carouselElement = document.getElementById(this.carouselId);

    if (!carouselElement) return;

    const productCount = parseInt(carouselElement.dataset.productCount, 10);
    const pageWidth = document.body.offsetWidth;
    const isDesktop = pageWidth > DESKTOP_WIDTH;
    const productCountTarget = isDesktop ? 4 : 2;
    const isEnabled = productCount > productCountTarget;

    if (!isEnabled) {
      const navigationWrapper = document.getElementById(
        this.navigationWrapperId
      );
      navigationWrapper?.classList?.add('!hidden');
    }

    const pagination = isEnabled
      ? {
          pagination: {
            el: `#${this.paginationId}`,
            type: 'bullets',
          },
        }
      : {};

    const navigation = isEnabled
      ? {
          navigation: {
            nextEl: `#${this.navigationNextId}`,
            prevEl: `#${this.navigationPrevId}`,
          },
        }
      : {};

    this.swiper = new Swiper(`#${this.carouselId}`, {
      speed: DEFAULT_SLIDER_SPEED,
      spaceBetween: this.gap,
      loop: false,
      slidesPerView: 1.1,
      centeredSlides: false,
      breakpoints: {
        [DESKTOP_WIDTH]: {
          slidesPerView: 4,
        },
      },
      ...pagination,
      ...navigation,
      watchOverflow: true,
    });
  }

  setArrowPositions() {
    const firstSlide = this.container.querySelector('.swiper-slide');
    if (!firstSlide) return;

    const img = firstSlide.querySelector('img');
    if (!img) return;
    const height = img.offsetHeight;

    this.navigation.style.setProperty('top', `${height / 2}px`);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    window.removeEventListener('resize', this.setArrowPositions);
  }
}

customElements.define('post-block-slider', PostBlockSlider);
